import { forwardRef, useId } from "react";

import { FormHelperText } from "@mui/material";

import { usePhoneField } from "./PhoneField.hooks";
import {
  AddonWrapper,
  Container,
  Input,
  InputWrapper,
} from "./PhoneField.styles";
import { TextFieldProps, TextFieldReference } from "./PhoneField.types";
import InputLabel from "../InputLabel/InputLabel";

const TextField = forwardRef<TextFieldReference, TextFieldProps>(
  (
    {
      label,
      id,
      defaultValue,
      value,
      readOnly,
      fullWidth = true,
      InputProps = {},
      addonBefore,
      addonBeforeProps,
      addonAfter,
      addonAfterProps,
      helperText,
      onChangeEvent,
      onChange,
      ...innerProps
    },
    ref
  ) => {
    const { textfieldRef, valueState, onChangeHandler } = usePhoneField({
      ref,
      defaultValue,
      value,
      onChangeEvent,

      onChange,
    });
    const formId = useId();

    return (
      <Container>
        {!!label && (
          <InputLabel htmlFor={id ?? formId} required={innerProps.required}>
            {label}
          </InputLabel>
        )}
        <InputWrapper fullWidth={fullWidth} color={innerProps.color}>
          {addonBefore ? (
            <AddonWrapper
              placement="before"
              disabled={innerProps.disabled}
              {...addonBeforeProps}
            >
              {addonBefore}
            </AddonWrapper>
          ) : null}
          <Input
            withAddonBefore={!!addonBefore}
            withAddonAfter={!!addonAfter}
            id={id ?? formId}
            variant="outlined"
            size="small"
            ref={textfieldRef}
            fullWidth={fullWidth}
            value={valueState}
            // defaultCountry="VN"
            onChange={onChangeHandler}
            InputProps={{
              readOnly,
              ...InputProps,
            }}
            {...innerProps}
          />
          {addonAfter ? (
            <AddonWrapper
              placement="after"
              disabled={innerProps.disabled}
              {...addonAfterProps}
            >
              {addonAfter}
            </AddonWrapper>
          ) : null}
        </InputWrapper>
        {helperText ? (
          <FormHelperText
            variant="outlined"
            required={innerProps.required}
            error={innerProps.error}
            disabled={innerProps.disabled}
          >
            {helperText}
          </FormHelperText>
        ) : null}
      </Container>
    );
  }
);

export default TextField;
